import './style.scss';
import $ from 'jquery';
import { gsap } from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

gsap.registerPlugin(ScrollTrigger);

function revealFunction() {
	if(!$(".wp-block-thefuturblocks-clients__container.anim-reveal").length) {
		return;
	}

	ScrollTrigger.batch(".wp-block-thefuturblocks-client", {
	  onEnter: batch => {
	    batch.forEach((section, i) => {
	      gsap.fromTo(section, {autoAlpha:0,y:20}, {
	      	autoAlpha: 1,
	      	y: 0,
	        duration: 0.6,
	        stagger: 0.1,
	        delay: i * 0.3,
	      });
	    });
	  },
		  once: true,
	  start: "+=100 bottom"
	});
}

function hoverFunction() {
	if($(".wp-block-thefuturblocks-clients").length) {
		return;
	}
	$('.wp-block-thefuturblocks-clients').each(function(i,el) {
		var self = $(this),
			img = self.find(".wp-block-thefuturblocks-client__image"),
			activeBox = $(this).find('.wp-block-thefuturblocks-client__image.active'),
			notActiveBox = $(this).find('.wp-block-thefuturblocks-client__image:not(.active)');

		self.on('mouseleave', () => {
			gsap.to(img, { filter: 'grayscale(0)', autoAlpha:1,duration:0.3 });
		})

		img.each(function() {
			$(this).on('mouseenter', function() {
				$(this).addClass('active')
				gsap.to($(el).find('.wp-block-thefuturblocks-client__image.active'), {filter:'grayscale(0)',autoAlpha:1,duration:0.3});
				gsap.to($(el).find('.wp-block-thefuturblocks-client__image:not(.active)'), {filter:'grayscale(1)', autoAlpha:0.4,duration:0.3});
			}).on('mouseleave', function() {
				$(this).removeClass('active')
			})
		})
	})
}

$(window).on('load', () => {
  if($('.c-loader').length) {
    gsap.delayedCall(4, function() {
      revealFunction();
    })
  } else {
    gsap.delayedCall(0.4, function() {
      revealFunction();
    })
  }
  hoverFunction()
})